import '@fontsource/press-start-2p';
import './ui/style.css';
import { Game } from './game/game';

const game = new Game();
if (new URLSearchParams(location.search).has('debug')) (window as unknown as { __sms: Game }).__sms = game;
game.start().catch((err) => {
  console.error(err);
  document.body.insertAdjacentHTML(
    'beforeend',
    `<div style="position:fixed;inset:0;display:grid;place-items:center;background:#352879;color:#fff;font:12px monospace;padding:24px;text-align:center">
      Sorry, the game couldn't start on this browser (WebGL needed).<br><br>${String(err?.message ?? err)}
    </div>`,
  );
});

// Installable + offline (design.md B12.4). Not in dev: Vite serves unhashed modules.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(() => navigator.serviceWorker.ready)
      .then((reg) => {
        // Cache what this first visit already loaded (before the worker was in control).
        const urls = performance
          .getEntriesByType('resource')
          .map((e) => new URL(e.name))
          .filter((u) => u.origin === location.origin && u.pathname.startsWith('/assets/'))
          .map((u) => u.pathname);
        reg.active?.postMessage({ type: 'cache', urls });
      })
      .catch(() => undefined);
  });
}
